<template>
  <DBox
    :addButton="false"
    :addLink="false"
    :id="'cmp-accounting-cost_sidewindow-cost_lines_vat'"
  >
    <Radio2
      :disabled="selectedCostsDetails.disabled"
      :id="'tax_calculation'"
      :label="'Tax Calculation'"
      :options="[
        { text: $t('excluding_VAT'), value: '1' },
        { text: $t('including_VAT'), value: '2' },
        { text: $t('no_VAT'), value: '3' },
      ]"
      :value="vat_handling"
      @input="onRadioChange"
    />
    <TextField2
      v-if="vat_handling == 1 || vat_handling == 2"
      :id="'vat_rate1'"
      :placeholder="$t('type_in_vat1')"
      :label="$t('vat1')"
      :value="selectedCostsDetails.invoice.vat_rate1"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      v-if="vat_handling == 1 || vat_handling == 2"
      :id="'vat_rate2'"
      :placeholder="$t('type_in_vat2')"
      :label="$t('vat2')"
      :value="selectedCostsDetails.invoice.vat_rate2"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <TextField2
      v-if="vat_handling == 1 || vat_handling == 2"
      :id="'vat_rate3'"
      :placeholder="$t('type_in_vat3')"
      :label="$t('vat3')"
      :bb="'none'"
      :value="selectedCostsDetails.invoice.vat_rate3"
      @blur="(e) => onTextFieldValueChange(e)"
    />
    <Dropdown2
      v-if="vat_handling == 3"
      :label="$t('withholding_tax')"
      :disabled="selectedCostsDetails.disabled"
      deselect
      :options="selectedCostsDetails.tax_deductionsTV"
      :selected="
        selectedCostsDetails.tax_deductionsTV.find(
          (c) => c.value == selectedCostsDetails.invoice.tax_type_id_deduction
        )
      "
      :placeholder="$t('Withholding Tax')"
      v-on:selectedChange="(e) => onDropdownChange('tax_type_id_deduction', e)"
      bb="0px"
    />
  </DBox>
</template>

<script>
import { EventHooks } from "../../../../plugins/text-field";
import { CostsService } from "../../services/costs.service";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import { AccountingStoreNamespace as storeNS } from "../../store";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { async } from "ramda-adjunct";
export default {
  components: {},
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      systemCurrency: "EUR",
      textFieldConfig: {
        height: 35,
        showEditIconOnHover: false,
        box: true,
        valueChangedEvent: EventHooks.OnBlur,
      },
      costVatHandling: 0,
      isTaxTypesModal: false,
      taxTypes: [],
    };
  },
  computed: {
    vat_handling: function () {
      return this.selectedCostsDetails.invoice.vat_handling || 4;
    },
    exchangeRate() {
      if (!this.costOverview) {
        return 0;
      }

      let exchange_rate_creation =
        Number(
          this.costOverview.net_amount_cc / this.costOverview.net_amount_sc
        ) || 0;
      return exchange_rate_creation.toFixed(2);
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onRadioChange: async function ({ value }) {
      if (value == 4) {
        this.onAddClick();
      } else {
        const res = await CostsService.updateVatHandling(
          this.selectedCostsDetails.invoice.invoice_id,
          value
        );
        if (res) {
          CostsService.findCostOverViewTabData(
            this.selectedCostsDetails.invoice.invoice_id
          ).then((res1) => {
            this[ActionTypes.AccountingCostOverview.SET.ALL]({
              invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
              overview: res1.data || [],
            });
          });
        }
      }
    },
    onAddClick: function () {
      openModalRoute(this, "tax_type_modal", {
        mode: "add",
      });
    },
    onOpenTaxTypesModal() {
      this.isTaxTypesModal = true;
      CostsService.findTaxTypes().then((res) => {
        this.taxTypes = res.data.tax_types;
      });
    },
    onTaxTypeCanceled(item) {
      this.isTaxTypesModal = false;
      this.costVatHandling = this.costOverview.invoice.vat_handling || 4;
    },
    onTaxTypeSelected(item) {
      this.isTaxTypesModal = false;
      CostsService.updateInvoiceTaxType(
        this.costOverview.invoice.invoice_id,
        item.tax_type_id
      );
    },
    onTextFieldValueChange: function ({ name, value }) {
      this.selectedCostsDetails.invoice[name] = value;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("change_tax_deduc", {
        name: "tax_type_id_deduction",
        value: value.value,
      });
    },
    // onInvoiceTextFieldValueChange: function (columnName, columnValue) {
    //   CostsService.modify_invoices(
    //     this.costOverview.invoice.invoice_id,
    //     columnName,
    //     columnValue
    //   );
    // },
  },
  watch: {
    selectedCostsDetails: function (n) {
      if (n) {
        this.costVatHandling = n.invoice.vat_handling || 4;
      }
    },
  },
};
</script>


<style lang="scss">
.cmp-accounting-cost_sidewindow-cost_lines_vat {
  .summary-container {
    padding: 14px 18px;
  }
  .cb-item {
    display: flex;
    align-items: center;
    padding: 1px;
  }
  .cost_lines_row {
    flex-direction: row;
    display: flex;
    // padding: 5px 0 6px;
    border-bottom: 1px solid var(--sprt-85);
    .cost_lines_text {
      flex: 1;
      padding-left: 5px;
      p {
        margin-bottom: 0;
      }
    }
    .cost_lines_value {
      flex: 2;
      align-self: center;
    }
  }
}
</style>
